import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSofa = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		clipRule: "evenodd",
		d: "M4.282.86v10.528H1.047v6.353h2.706v2.647h2v-2.647h8.588v2.647h2v-2.647h2.706v-6.353h-3.235V.86H4.282zm9.53 10.528V2.86h-7.53v8.53h7.53zm-10.765 2h14v2.353h-14v-2.353z",
		fillRule: "evenodd",
		fill: "#111"
	})
});
export default SvgSofa;
